import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./fonts.css";
import "./theme.css";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
